// DS: i4.43
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import IconWrap, { Props } from '../../IconWrap';

const NoDerivatives: React.FC<Props> = props => {
  const uniqueId = useUniqueId();
  return (
    <IconWrap {...props}>
      <svg
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath={`url(#i443-${uniqueId})`}>
          <path d="M7.986 0c2.238 0 4.133.776 5.686 2.329C15.224 3.872 16 5.76 16 8c0 2.239-.762 4.114-2.286 5.628C12.104 15.21 10.194 16 7.986 16c-2.163 0-4.038-.786-5.629-2.357C.786 12.07 0 10.19 0 8 0 5.82.786 3.93 2.357 2.33 3.91.775 5.787 0 7.986 0Zm.03 1.443c-1.82 0-3.358.642-4.615 1.929C2.095 4.696 1.443 6.239 1.443 8c0 1.781.648 3.314 1.943 4.6 1.295 1.296 2.838 1.943 4.629 1.943 1.78 0 3.333-.652 4.656-1.957 1.258-1.22 1.886-2.748 1.886-4.586 0-1.828-.638-3.371-1.914-4.628-1.267-1.287-2.81-1.93-4.628-1.93Zm3.013 4.671v1.371H5.215V6.114h5.814Zm0 2.572v1.37H5.215v-1.37h5.814Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={`i443-${uniqueId}`}>
            <path fill="currentColor" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    </IconWrap>
  );
};
NoDerivatives.displayName = 'NoDerivatives';

export default NoDerivatives;
